import { useParams } from "react-router-dom";
import { ROUTE_LABELS } from "@/components/layout/navConfig";

function deslugify(slug) {
  return (slug || "")
    .split("-")
    .filter(Boolean)
    .map((w) => w.charAt(0).toUpperCase() + w.slice(1))
    .join(" ");
}

export default function ComingSoon() {
  const { group, module } = useParams();
  const entry = ROUTE_LABELS[`${group}/${module}`];
  const moduleLabel = entry?.label || deslugify(module);
  const groupLabel = entry?.groupLabel || deslugify(group);

  return (
    <div
      className="flex min-h-[60vh] flex-col items-center justify-center gap-3 text-center"
      data-testid="coming-soon-page"
    >
      <p
        className="text-xs font-semibold uppercase tracking-[0.18em] text-muted-foreground"
        data-testid="coming-soon-group"
      >
        {groupLabel}
      </p>
      <h1 className="text-2xl font-bold text-foreground" data-testid="coming-soon-module">
        {moduleLabel}
      </h1>
      <p className="text-sm text-muted-foreground" data-testid="coming-soon-message">
        This module is planned.
      </p>
    </div>
  );
}
